<div *ngIf="fullname" class="page-main-header">
    <div class="main-header-container">
        <div class="main-header-left">
            <div class="logo-wrapper">
                <img class="img-fluid" src="./assets/images/sanetPN.svg" alt="logo">
				<img class="img-fluid dark-logo" src="./assets/images/dark-logo.svg" alt="logo">
            </div>
        </div>

        <!-- Nav Tabs -->
        <div class="main-header-tabs">
            <a mat-button mat-stroked-button color="" class="tab-btn-fixed" routerLink="/home"><i class="far fa-box-open-full"></i></a>
            <nav class="tabs-nav">
                <app-top-navbar-tab (closeTab)="closeTab($event)" *ngFor="let tab of tablist" [navTab]="tab"/>
            </nav>
        </div>


        <!-- User panel -->
        <div *ngIf="viewPanel" class="main-header-right">
            <ul class="nav-menus">
                <li><button mat-button class="nav-menus-btn d-none d-lg-block" (click)="openFullscreen()" disableRipple><i class="far fa-expand"></i></button></li>
                <li style="display:none;">
                    <button mat-button [matMenuTriggerFor]="idiom" #language="matMenuTrigger" class="nav-menus-btn" disableRipple><i class="far fa-globe"></i></button>
                    <mat-menu #idiom="matMenu" [overlapTrigger]="false" xPosition="before" class="nav-submenu nav-lang">
                        <div (mouseleave)="language.closeMenu()" class="nav-submenu-wrp">
                            <button mat-menu-item [ngClass]="{'active': languageCve === option.languageCve}" *ngFor="let option of languages" (click)="selectLanguage(option)">{{option.language}} <i class="far fa-check text-primary"></i></button>
                        </div>
                    </mat-menu>
                </li>
                <li>
                    <button mat-button [matMenuTriggerFor]="noti" #menuTrigger="matMenuTrigger" class="nav-menus-btn" aria-label="Botón notificaciones" matBadge="4" matBadgeColor="warn" matBadgeSize="small" [matBadgeHidden]="hiddenBadge" (click)="hideBadge()" disableRipple><i class="far fa-bell"></i></button>
                    <mat-menu #noti="matMenu" [overlapTrigger]="false" xPosition="before" class="nav-submenu notification-dropdown">
                        <div (mouseleave)="menuTrigger.closeMenu()" class="nav-submenu-wrp">
                            <h3 class="nav-submenu-title noti-title-badge" matBadge="4" matBadgeOverlap="false">Tienes 4 notificaciones</h3>
                            <!-- ejemplo notificaciones Otros perfiles -->
                            <ul class="noti-list" *ngIf="userProfileExample === 'other'">
                                <li class="noti-item nav-item-primary" mat-menu-item>
                                    <span class="noti-icon bg-light-primary"><i></i></span>
                                    <div class="noti-body">
                                        <p>Alta de paciente</p>
                                        <span class="noti-subtle">Hace 10 minutos</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-secondary" mat-menu-item>
                                    <span class="noti-icon bg-light-secondary"><i></i></span>
                                    <div class="noti-body">
                                        <p>Cambio de turno</p>
                                        <span class="noti-subtle">Hace 1 hora</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-success" mat-menu-item>
                                    <span class="noti-icon bg-light-success"><i></i></span>
                                    <div class="noti-body">
                                        <p>Revisión cama 8</p>
                                        <span class="noti-subtle">Hace 3 horas</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-danger" mat-menu-item>
                                    <span class="noti-icon bg-light-danger"><i></i></span>
                                    <div class="noti-body">
                                        <p>Chequeo signos vitales</p>
                                        <span class="noti-subtle">Hace 6 horas</span>
                                    </div>
                                </li>
                            </ul>
                            <!-- ejemplo notificacicones Médico -->
                            <ul class="noti-list" *ngIf="userProfileExample === 'doctor'">
                                <li class="noti-item nav-item-success" mat-menu-item>
                                    <span class="noti-icon bg-light-success"><i class="far fa-message-check"></i></span>
                                    <div class="noti-body">
                                        <p class="text-success">Solicitud de referencia aceptada</p>
                                        <span class="noti-subtle">N° de folio: 95490</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-danger" mat-menu-item>
                                    <span class="noti-icon bg-light-danger"><i class="far fa-message-xmark"></i></span>
                                    <div class="noti-body">
                                        <p class="text-danger">Solicitud de referencia rechazada</p>
                                        <span class="noti-subtle">N° de folio: 95489</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-success" mat-menu-item>
                                    <span class="noti-icon bg-light-success"><i class="far fa-message-check"></i></span>
                                    <div class="noti-body">
                                        <p class="text-success">Solicitud de contrarreferencia aceptada</p>
                                        <span class="noti-subtle">N° de folio: 95488</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-danger" mat-menu-item>
                                    <span class="noti-icon bg-light-danger"><i class="far fa-message-xmark"></i></span>
                                    <div class="noti-body">
                                        <p class="text-danger">Solicitud de contrarreferencia rechazada</p>
                                        <span class="noti-subtle">N° de folio: 95487</span>
                                    </div>
                                </li>
                            </ul>
                            <!-- ejemplo notificaciones de Jefe de servicio -->
                            <ul class="noti-list" *ngIf="userProfileExample === 'headOfService'">
                                <li class="noti-item nav-item-caution" mat-menu-item>
                                    <span class="noti-icon bg-light-caution"><i class="far fa-message-exclamation"></i></span>
                                    <div class="noti-body">
                                        <p class="text-caution">Solicitud de referencia pendiente</p>
                                        <span class="noti-subtle">N° de folio: 95481</span>
                                    </div>
                                </li>
                                <li class="noti-item nav-item-caution" mat-menu-item>
                                    <span class="noti-icon bg-light-caution"><i class="far fa-message-exclamation"></i></span>
                                    <div class="noti-body">
                                        <p class="text-caution">Solicitud de contrareferencia pendiente</p>
                                        <span class="noti-subtle">N° de folio: 95480</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </mat-menu>
                </li>
                <li class="ms-auto ms-sm-0">
                    <button [matMenuTriggerFor]="profile" #user="matMenuTrigger" class="nav-menus-btn-user">
                        <img class="avatar rounded-circle me-2" src="./assets/images/1.png" alt="avatar">
                        <div>{{ 'lbl_hola' | translate : listTraduction.lbl }}, <br><span class="nav-name-user">{{fullname}}</span></div>
                        <i class="ms-2 far fa-chevron-down"></i>
                    </button>
                    <mat-menu #profile="matMenu" [overlapTrigger]="false" xPosition="before" class="nav-submenu">
                        <div (mouseleave)="user.closeMenu()" class="nav-submenu-wrp">
                            <h3 class="nav-submenu-title">{{ 'lbl_perfil_usr' | translate : listTraduction.lbl }}</h3>
                            <button mat-menu-item type="button" (click)="onViewProfile()">{{ 'lbl_editar_perfil' | translate : listTraduction.lbl }}</button>
                            <a routerLink="/configuration/change-pwd" mat-menu-item>{{ 'lbl_contrasenia' | translate : listTraduction.lbl }}</a>
                            <button type="button" class="nav-item-warning text-warning" mat-menu-item (click)="lockSession()">Bloquear sesión</button>
                            <button type="button" class="nav-item-danger text-danger" mat-menu-item (click)="logout()">{{ 'lbl_cerrar_sesion' | translate : listTraduction.lbl }}</button>
                        </div>
                    </mat-menu>
                </li>
            </ul>
        </div>
        <button class="d-sm-none mobile-toggle" (click)="showPanel()"><i class="far fa-ellipsis"></i></button>
    </div>
</div>
<app-login-session-lock ></app-login-session-lock>
<loading-indicator [detectRouteTransitions]="true">
    <ng-template #loading>
        <div class="loader-container"><div class="loader"></div></div>
    </ng-template>
</loading-indicator>
